export const text = {
  required: true,
  max: 255
}

export const name = {
  required: true,
  onlyLetters: true,
  min: 2,
  max: 255
}

// Правило валидации имени и фамилии для паспорта, менее строгое, чем name
export const nameUnrestricted = {
  required: true,
  nameUnrestricted: true,
  min: 2,
  max: 255
}

export const addressUnrestricted = {
  required: true,
  addressUnrestricted: true,
  min: 3,
  max: 1000
}

export const phone = {
  required: true,
  phoneFormat: true,
  phoneMinLength: 10,
  phoneMaxLength: 20
}

export const email = {
  required: true,
  email: true,
  min: 6,
  max: 255
}

export const url = {
  required: true,
  urlStart: true,
  url: true
}

export const passwordFirstInput = {
  required: true,
  passwordRegex: /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]*$/,
  passwordMinLength: 8
}

export const passwordConfirmed = {
  required: true,
  passwordConfirmed: 'password'
}

export const signupBirthDay = {
  required: true,
  isDate: true,
  minAge: 12,
  maxAge: 120
}

export const file = {
  required: true,
  size: 3000
}
